import { render } from "./NewAchieve.vue?vue&type=template&id=275740ec"
import script from "./NewAchieve.vue?vue&type=script&lang=js"
export * from "./NewAchieve.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__